import { render, staticRenderFns } from "./Deposite.vue?vue&type=template&id=ce872fda&scoped=true"
import script from "./Deposite.vue?vue&type=script&lang=js"
export * from "./Deposite.vue?vue&type=script&lang=js"
import style0 from "./Deposite.vue?vue&type=style&index=0&id=ce872fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce872fda",
  null
  
)

export default component.exports